var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"draggable",style:({ top: _vm.top + 'px', left: _vm.left + 'px', width: _vm.blockWidth + 'px', height: _vm.blockHeight + 'px'}),on:{"mousedown":_vm.startDragging}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }